import React from 'react';

import { useLocalize } from '../../../hooks';
import { Button } from '../../../components';
import type { QuizType } from '../../../api';
import type { AnswersContainerType } from '../useQuiz';
import clsx from 'clsx';

export type FooterProps = {
  isMobile?: boolean;
  finishing: boolean;
  canGoLeft: boolean;
  canGoRight: boolean;
  quiz: QuizType | null;
  answers: AnswersContainerType;

  handleGoLeft: () => void;
  handleGoRight: () => void;
  handleFinishQuiz: () => void;
};

export const Footer: React.FC<FooterProps> = ({
  isMobile,
  canGoLeft,
  canGoRight,
  handleGoLeft,
  handleGoRight,

  quiz,
  answers,
  finishing,
  handleFinishQuiz,
}) => {
  const { t } = useLocalize();

  const questionsCount = quiz?.questions?.length || 0;
  const fullAnswers =
    Object.values(answers).filter(a => a.length).length === questionsCount;

  return (
    <div
      className={clsx(
        isMobile ? 'pb-lg' : 'pb-2xl',
        'mt-auto w-full pt-lg bottom-0 flex gap-x-md items-center justify-between border-solid border-accordionBorder'
      )}
    >
      <Button
        type="empty"
        disabled={!canGoLeft}
        onClick={handleGoLeft}
        label={t('quiz.page.prev')}
        className="w-[20rem] px-md flex-row-reverse bg-white border border-blackBorder text-blackBorder hover:bg-goToPracticeHover hover:border-transparent hover:text-white"
      />
      {canGoRight ? (
        <Button
          type="empty"
          disabled={!canGoRight}
          onClick={handleGoRight}
          label={t('quiz.page.next')}
          className="w-[20rem] px-md flex-row-reverse bg-blackBorder border-blackBorder text-contrast hover:bg-goToPracticeHover hover:border-transparent"
        />
      ) : (
        <Button
          type="empty"
          loading={finishing}
          disabled={!fullAnswers}
          onClick={handleFinishQuiz}
          label={t('quiz.page.finish')}
          className="w-[20rem] px-md flex-row-reverse bg-blackBorder border-blackBorder text-contrast hover:bg-goToPracticeHover hover:border-transparent"
        />
      )}
    </div>
  );
};
